import { Skeleton } from '@mantine/core';
import { clsx } from 'clsx';

import styles from './FreightRateCard.module.css';

import type { FreightRateCardLayout } from './FreightRateCard';

type FreightRateCardSkeletonProps = {
  layout?: FreightRateCardLayout;
};

export const FreightRateCardSkeleton = ({ layout = 'vertical' }: FreightRateCardSkeletonProps) => {
  const isHorizontal = layout === 'horizontal';

  return (
    <div className={clsx(styles.card, isHorizontal && styles.cardHorizontal)} data-testid='freight-rate-card-skeleton'>
      <div className={styles.header}>
        <Skeleton className={styles.logoBox} radius='sm' />
        <div className={isHorizontal ? styles.carrierBlock : undefined}>
          <Skeleton height={14} mb={6} radius='sm' width='60%' />
          <Skeleton height={12} radius='sm' width='40%' />
        </div>
      </div>
      <div className={clsx(styles.selectors, isHorizontal && styles.selectorsHorizontal)}>
        <Skeleton height={64} radius='sm' />
        <Skeleton height={64} radius='sm' />
      </div>
    </div>
  );
};
